import { t } from 'ttag'
import styled from 'styled-components'

import { Text } from '@h2/components/typography/text'
import { Link } from '@h2/common/components/link'
import personSvg from '@h2/assets/svg/illustrations/person.svg'
import { Flex } from '@h2/components/layout/flex'

const PersonImage = styled.img`
  max-width: 30%;
`
const AccountPortability = () => {
  return (
    <Flex gap="15px">
      <PersonImage src={personSvg} />
      <div>
        <Text>{t`A ${dynamicValues.systemName} account is yours for life, all you need to do is make sure to setup a username and password -- and, hopefully an e-mail address, so you can reset your password if you forget it.`}</Text>
        <Text>{t`Adding that information is easy to do, just visit the Update Profile section to change your password and/or establish a username.`}</Text>
        <Link
          variant="button"
          href="/personalprofile/edit/personalInfo"
          size="large"
          weight="bold">
          {t`Set one up now`}
        </Link>
      </div>
    </Flex>
  )
}

export { AccountPortability }
